// extracted by mini-css-extract-plugin
module.exports = {"features":"_aG","features__item":"_aH","card":"_aI","card__header":"_aJ","card__image":"_aK","card__title":"_aL","card__body":"_aM","card__link":"_aN","features__itemsGroup":"_aO"};